/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RoadFeatureType {
    BOMSTASJON = 'Bomstasjon',
    RASTEPLASS = 'Rasteplass',
    VEGKAMERA = 'Vegkamera',
    HEIGHT = 'Height',
    DOGNHVILEPLASS = 'Dognhvileplass',
    LADESTASJON = 'Ladestasjon',
    LENGTH = 'Length',
    TURISTVEG = 'Turistveg',
    WEIGHT = 'Weight',
    FERGE = 'Ferge',
    DATEX3TRAFFIC_MESSAGE = 'Datex3TrafficMessage',
    TRAFFIC_MESSAGE = 'TrafficMessage',
    SWEDISH_TRAFFIC_MESSAGE = 'SwedishTrafficMessage',
    FINNISH_TRAFFIC_MESSAGE = 'FinnishTrafficMessage',
    VEGSPERRING = 'Vegsperring',
    VARUTSATT_VEG = 'VarutsattVeg',
    MEASUREMENT_SITE = 'MeasurementSite',
    JERNBANEKRYSSING_MED_SAERSKILT_FARE = 'JernbanekryssingMedSaerskiltFare',
    TUNNEL = 'Tunnel',
    TRAFIKKREGULERING = 'Trafikkregulering',
    GJENNOMKJORING_FORBUDT = 'GjennomkjoringForbudt',
}
